import { NgModule } from '@angular/core';
import { UserRoleEnum } from './backend/model/userRoleEnum';
import { AuthGuard } from './core/guards/auth.guard';
import { GuestGuard } from './core/guards/guest.guard';
import { RoleGuard } from './core/guards/role.guard';
import { PublicLayoutComponent } from './core/layouts/public-layout/public-layout.component';
import { SecureLayoutComponent } from './core/layouts/secure-layout/secure-layout.component';
import { CategoriesComponent } from './pages/categories/categories.component';
import { DashboardComponent } from './pages/dashboard/dashboard.component';
import { DonationsComponent } from './pages/donations/donations.component';
import { FamiliesComponent } from './pages/families/families.component';
import { ListsComponent } from './pages/lists/lists.component';
import { LoginComponent } from './pages/login/login.component';
import { MembersComponent } from './pages/memberes/members.component';
import { NeedsComponent } from './pages/needs/needs.component';
import { NotFoundComponent } from './pages/not-found/not-found.component';
import { OrganisationMembersComponent } from './pages/organisation-members/organisation-members.component';
import { UsersComponent } from './pages/users/users.component';
import { RouterModule, Routes } from '@angular/router';

const routes: Routes = [
  {
    path: '',
    component: SecureLayoutComponent,
    canActivate: [AuthGuard],
    children: [
      {
        path: 'dashboard',
        component: DashboardComponent,
      },
      {
        path: '',
        component: FamiliesComponent,
      },
      {
        path: 'users',
        component: UsersComponent,
        canActivate: [RoleGuard],
        data: { roles: [UserRoleEnum.SystemAdministrator] },
      },
      {
        path: 'families',
        component: FamiliesComponent,
        canActivate: [RoleGuard],
        data: { roles: [UserRoleEnum.SystemAdministrator] },
      },
      {
        path: 'members',
        component: MembersComponent,
        canActivate: [RoleGuard],
        data: { roles: [UserRoleEnum.SystemAdministrator] },
      },
      {
        path: 'categories',
        component: CategoriesComponent,
        canActivate: [RoleGuard],
        data: { roles: [UserRoleEnum.SystemAdministrator] },
      },
      {
        path: 'needs',
        component: NeedsComponent,
        canActivate: [RoleGuard],
        data: { roles: [UserRoleEnum.SystemAdministrator] },
      },
      {
        path: 'organisationMembers',
        component: OrganisationMembersComponent,
        canActivate: [RoleGuard],
        data: { roles: [UserRoleEnum.SystemAdministrator] },
      },
      {
        path: 'lists',
        component: ListsComponent,
        canActivate: [RoleGuard],
        data: { roles: [UserRoleEnum.SystemAdministrator] },
      },
    ],
  },
  {
    path: '',
    component: PublicLayoutComponent,
    children: [
      {
        path: 'login',
        component: LoginComponent,
        canActivate: [GuestGuard],
      },
      {
        path: 'donations',
        component: DonationsComponent,
      },
    ],
  },
  {
    path: 'not-found',
    component: NotFoundComponent,
  },
  { path: '**', redirectTo: '/not-found' },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { onSameUrlNavigation: 'reload' })],
  exports: [RouterModule],
})
export class AppRoutingModule {}
